import { createGridSelectionRowRenderer } from "../../renderers/selectionGridRow";
export function gridSingleSelectionPlugin(config) {
    return function () { return ({
        rowRenderer: createGridSelectionRowRenderer({
            onSelect: config.onSelect,
            isSelected: config.isSelected,
            onContextMenu: config.onContextMenu,
            onRowClick: config.onRowClick
        })
    }); };
}
//# sourceMappingURL=gridSingleSelectionPlugin.js.map